import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';

@Injectable({
    providedIn: 'root'
})
export class ErrorService {

    getClientMessage(error: Error): string {
        if (!navigator.onLine) {
            return 'No Internet Connection';
        }
        return error.message ? error.message : error.toString();
    }

    getClientStack(error: Error): any {
        return error.stack;
    }

    getServerMessage(error: HttpErrorResponse): string {
        return error.message;
    }

    getServerStack(error: HttpErrorResponse): any {
        // handle stack trace
        const errorObject = {
          error: error.error,
          message: error.message,
          name: error.name,
          status: error.status,
          url: error.url,
          methodName: error.url?.split("/")[error.url?.split("/").length-1],
          serviceName: error.url?.split("/")[error.url?.split("/").length-2]
        }
        return errorObject;
    }
}
